import { AccountCowboyHatIcon } from './AccountCowboyHatIcon';

/**
 * author: Augustin Ursu
 * id 18963ABD-E908-4E3C-B8DA-D87916F269F7
 * name account-cowboy-hat
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-cowboy-hat.svg
 * tags
 * - Account / User 
 * - Agriculture 
 */
export const RancherIcon = AccountCowboyHatIcon;
export default RancherIcon